import { useState } from "react";
import content from "../../data/content";
import CtaBanner from "../../components/CtaBanner";
import "./Services.css";

const { services } = content;

export default function Services() {
  const [selectedId, setSelectedId] = useState(null);

  // Which categories to show in the gallery view
  const filtered =
    selectedId === "all"
      ? services.categories
      : services.categories.filter((c) => c.id === selectedId);

  return (
    <div className="services-page">
      <section className="services-header">
        <p className="page-label">Services</p>
        <h1 className="page-heading">服務項目</h1>
      </section>

      {selectedId === null ? (
        /* ---- Category Picker ---- */
        <section className="services-picker">
          <div className="services-picker__grid">
            {/* "全部" card */}
            <button
              className="services-picker__card"
              onClick={() => setSelectedId("all")}
            >
              <img
                className="services-picker__img"
                src={services.categories[0].items[0].image}
                alt="全部"
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <div className="services-picker__overlay" />
              <span className="services-picker__label">全部</span>
            </button>

            {services.categories.map((cat) => (
              <button
                key={cat.id}
                className="services-picker__card"
                onClick={() => setSelectedId(cat.id)}
              >
                <img
                  className="services-picker__img"
                  src={cat.items[0].image}
                  alt={cat.title}
                  onError={(e) => { e.target.style.display = "none"; }}
                />
                <div className="services-picker__overlay" />
                <span className="services-picker__label">
                  {cat.title.replace(/[【】]/g, "")}
                </span>
              </button>
            ))}
          </div>
        </section>
      ) : (
        <>
          {/* ---- Back + Filter Tabs ---- */}
          <div className="services-filter">
            <button
              className="services-filter__back"
              onClick={() => setSelectedId(null)}
            >
              ← 返回分類
            </button>
            <div className="services-filter__tabs">
              <button
                className={`services-filter__btn ${
                  selectedId === "all" ? "services-filter__btn--active" : ""
                }`}
                onClick={() => setSelectedId("all")}
              >
                全部
              </button>
              {services.categories.map((cat) => (
                <button
                  key={cat.id}
                  className={`services-filter__btn ${
                    selectedId === cat.id
                      ? "services-filter__btn--active"
                      : ""
                  }`}
                  onClick={() => setSelectedId(cat.id)}
                >
                  {cat.title.replace(/[【】]/g, "")}
                </button>
              ))}
            </div>
          </div>

          {/* ---- Service Categories ---- */}
          {filtered.map((cat) => (
            <section key={cat.id} id={cat.id} className="services-category">
              <div className="services-category__inner">
                <div className="services-category__header">
                  <h2 className="services-category__title">{cat.title}</h2>
                  <p className="services-category__slogan">{cat.slogan}</p>
                  <p className="services-category__desc">{cat.description}</p>
                </div>

                <div className="services-category__items">
                  {cat.items.map((item, i) => (
                    <div key={i} className="service-card">
                      <div className="service-card__image-wrap">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="service-card__image"
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                        <div
                          className="service-card__image-placeholder img-placeholder"
                          style={{ display: "none" }}
                        >
                          Photo
                        </div>
                      </div>
                      <div className="service-card__body">
                        <h3 className="service-card__name">{item.name}</h3>
                        <p className="service-card__desc">{item.description}</p>
                        {item.note && (
                          <p className="service-card__note">{item.note}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ))}
        </>
      )}

      <CtaBanner />
    </div>
  );
}
